import { Row, Col, Input, Button, Switch, Form } from 'antd';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { addUser, modifyUser } from './userSlice';

export default function AddUser(): JSX.Element {

    const dispatch = useDispatch();
    const { setModelChange, messageApi, editUser, setEditUser } = React.useContext(CommonContext) as CommonContextType;
    const [user_role, setRole] = useState('Contributor');
    const [isRoleChecked, setIsRoleChecked] = useState(false);
    const [form] = Form.useForm();

    React.useEffect(() => {
        if (editUser?.id) {
            if (editUser.user_role.toLowerCase() === "admin") {
                setRole("Admin")
                setIsRoleChecked(true)
            } else {
                setRole("Contributor")
                setIsRoleChecked(false)
            }
            form.setFieldsValue(editUser)
        }else{
            setRole("Contributor")
            setIsRoleChecked(false)
            form.resetFields();
        }
    }, [editUser, form]);

    const onRoleChange = (checked: boolean) => {
        checked ? setRole("Admin") : setRole("Contributor");
        setIsRoleChecked(checked)
    };

    const onFinish = (values: any) => {
        values.user_role = user_role.toUpperCase();
        values.user_sgid = values.user_sgid.trim();
        values.created_datetime = new Date().toLocaleString() + "";
        values.updated_datetime = "";
        if (editUser?.id) {
            //form type is edit
            values.updated_datetime = new Date().toLocaleString() + "";
            dispatch(modifyUser(values, editUser?.id))
           /*  messageApi.open({
                type: 'success',
                content: 'User updated successfully',
            }); */
        } else {
            dispatch(addUser(values))
            /* messageApi.open({
                type: 'success',
                content: 'User added successfully',
            }); */
        }
        setModelChange(false)
        setEditUser(null)
        form.resetFields();
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <Form
            form={form}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            {/* <Row justify="space-between">
                <Col span={20}>
                    <Form.Item name='user_search'>
                        <Input placeholder="Name, SGID" />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item>
                        <Button style={{ backgroundColor: '#018B98' }} type="primary" htmlType="submit" >Search</Button>
                    </Form.Item>
                </Col>
            </Row> */}
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={12}>
                    <Form.Item label="Name"
                        name='user_name'
                        rules={[
                            {
                                required: true,
                                message: 'Please enter name',
                            },
                        ]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>

                    <Form.Item label="SGID"
                        name='user_sgid'
                        rules={[
                            {
                                required: true,
                                message: 'Please enter SGID',
                            },
                        ]}>
                        <Input onInput={e => (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.toUpperCase()} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={12}>

                    <Form.Item label="Email"
                        name='user_email'
                        rules={[
                            {
                                required: true,
                                type: "email",
                                message: 'Please enter valid email',
                            },
                        ]}>
                        <Input type='email' onInput={e => (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.toLowerCase()} />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item label=" ">
                        <Switch checked={isRoleChecked} onChange={onRoleChange} checkedChildren="Admin" unCheckedChildren="Contributor" />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item>
                <Button className='submit-button' type="primary" htmlType="submit" >{editUser?.id ? 'Update':'Create'}</Button>
            </Form.Item>
        </Form>
    )
}